import styled from 'styled-components';
import Link from 'next/link';
import { fontTitle, fontBody } from 'Styles/fonts';
import breakpoint from 'Styles/breakpoints';

import Card from '../Card/Card';
import ButtonIconOriginal from '../Icons/ButtonIcon';
import { Text, Heading1 } from '../RichText/RichText.styled';

export const BuyAgainCard = styled(Card)`
  padding: 12px;
  margin-bottom: 16px;
  background-color: var(--background);
  box-shadow: unset;
  border: 1px solid var(--border);

  ${Heading1} {
    ${fontTitle(18)};

    ${breakpoint('large')} {
      ${fontTitle(18)};
    }
  }

  ${Text} {
    ${fontBody(14)};
    color: var(--ring);
    margin-top: 4px;
  }
`;

export const BuyAgainLink = styled(Link)`
  text-decoration: none;
`;

export const ButtonIcon = styled(ButtonIconOriginal).attrs({
  name: 'arrow-right',
  variant: 'primary'
})`
  ${fontTitle(16)};
  margin-top: 12px;
`;
